const signalR = require('@aspnet/signalr')
import { getToken } from '@/utils/auth'

let websockethost = 'http://localhost:13210/hubs/notification'
if (process.env.NODE_ENV === 'production') {
  websockethost = document.location.protocol + '//' + document.location.host + '/hubs/notification'
}
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      connection: undefined
    }
  },
  created() {
    this.hideDot = Cookies.get('hideDot') ? eval(Cookies.get('hideDot').toLowerCase()) || true : true
    if (getToken()) {
      this.initConnection()
    }
    window.addEventListener('beforeunload', e => {
      this.connection.stop()
    })
  },
  beforeDestroy() {
    this.connection.stop()
  },
  watch: {
    hideDot(val) {
      Cookies.set('hideDot', val)
    }
  },
  methods: {
    initConnection() {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(websockethost, { accessTokenFactory: () => getToken().substring(7) })
        .configureLogging(signalR.LogLevel.Information)
        .build()
      this.connection.start().then(() => {
      }).catch(function(err) {
        return console.error(err.toString())
      })
      // 同时登陆
      this.connection.on('ReceiveLogout', () => {
        this.$store.dispatch('FedLogOut').then(() => {
          this.$alert(this.$t('alert.fedLogOut'), this.$t('status.warning'), {
            type: 'warning',
            confirmButtonText: this.$t('buttons.determine'),
            callback: action => {
              window.location.href = window.location.origin
              this.$router.push('/login')
              // location.reload()
            }
          }).catch(() => {
            window.location.href = window.location.origin
            this.$router.push('/login')
            // location.reload()
          })
          
        }).then(() => {
         
        })
      })
      this.connection.on('ReceiveUpcoming', () => {
        this.$store.dispatch('changeHasTodo', true)
        this.$store.dispatch('changeStamp', parseInt(new Date().getTime() / 1000))
        this.$store.dispatch('changeTopStamp', parseInt(new Date().getTime() / 1000))
        const h = this.$createElement
        this.$notify({
          title: this.$t('buttons.notify'),
          message: h('p', {
            style: 'cursor: pointer',
            on: {
              // 绑定方法
              click: () => { this.handleTodoWorkFlow() }
            }
          }, this.$t('alert.receiveUpcoming')),
          type: 'warning'
        })
      })
      this.connection.on('ReceiveNotification', () => {
        this.hideDot = false
        this.$store.dispatch('changeTopStamp', parseInt(new Date().getTime() / 1000))
        const h = this.$createElement
        this.$notify({
          title: this.$t('buttons.notify'),
          message: h('p', {
            style: 'cursor: pointer',
            on: {
              // 绑定方法
              click: () => { this.handleMsg(0) }
            }
          }, this.$t('alert.receiveNotification')),
          type: 'warning'
        })
      })
      this.connection.on('ReceiveWarning', () => {
        this.hasWarning = true
        this.$store.dispatch('changeTopStamp', parseInt(new Date().getTime() / 1000))
        const h = this.$createElement
        this.$notify({
          title: this.$t('buttons.notify'),
          message: h('p', {
            style: 'cursor: pointer',
            on: {
              // 绑定方法
              click: () => { this.getWarningList() }
            }
          }, this.$t('alert.receiveWarning')),
          type: 'warning'
        })
      })
    }
  }
}

